import { createAsyncThunk } from '@reduxjs/toolkit';
import { hrWidgetService } from './HRWidget.service';
import { errorHandlerThunk } from '../../App/App.thunk';
import { HrWidgetData, HrWidgetResponse } from './HRWidget.type';

const THUNK_PREFIX = 'hrWidget';

export const getHrWidgetThunk = createAsyncThunk<HrWidgetData, void>(
  `${THUNK_PREFIX}/getHrWidgetThunk`,
  async (_, thunkAPI) => {
    try {
      const { data } = await hrWidgetService.get();
      return data.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const storeHrWidgetThunk = createAsyncThunk<HrWidgetData, HrWidgetData>(
  `${THUNK_PREFIX}/storeHrWidgetThunk`,
  async (payload, thunkAPI) => {
    try {
      const { data } = await hrWidgetService.save(payload);
      return data.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);
